/**
 * @packageDocumentation
 * @module f1/adt
 */

import { t_rec_open } from '../types';

export interface Omit {
  /**
   * Creates a copy of the `object` without the given `props`.
   *
   * @see Pick
   * @public
   * @param keys the list of keys to remove from the value
   * @param dictionary the dictionary to remove from
   * @function omit
   * @example
   *
   * ```ts
   * omit(['foo', 'baz'], {
   *   foo: 1,
   *   bar: 2,
   *   baz: 3
   * }) === { bar: 2 }
   * ```
   */
  <K extends string[], V extends t_rec_open, R extends V>(keys: K, dictionary: V): R;
  /**
   * {@link FnOmitValue}
   * @param value
   */
  <K extends string[], V extends t_rec_open, R extends V>(keys: K, dictionary: V): (keys: K, dictionary: V) => R;
}

/**
 * @see Omit
 */
export default (keys: string[], dictionary: t_rec_open) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return keys.reduce((newObj, val) => (({ [val]: dropped, ...rest }) => rest)(newObj), dictionary);
};
